import { useEffect } from 'react';

const SITE_ORIGIN = 'https://wpaauae.com';
const DEFAULT_TITLE = 'White Paper | Audit, Tax & Advisory Services in UAE | WPAA';
const DEFAULT_IMAGE = `${SITE_ORIGIN}/og-image.png`;
const DEFAULT_DESCRIPTION =
  'White Paper Accounts Auditing - Your trusted partner for audit, tax, and advisory services in UAE. Delivering excellence and integrity in financial compliance.';

const upsertMeta = (attr, key, content) => {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

/**
 * Sets document.title, meta description, Open Graph and Twitter tags
 * for the current route. Reverts to site defaults when page unmounts.
 */
const setImage = (src) => {
  upsertMeta('property', 'og:image', src);
  upsertMeta('property', 'og:image:secure_url', src);
  upsertMeta('name', 'twitter:image', src);
};

// `image` is a site-relative path to a 1200x630 preview image, e.g. '/og/vat-services-uae.png'.
const usePageSeo = ({ title, description, path, noindex = false, image }) => {
  if (typeof window === 'undefined' && globalThis.__WPAA_SSR__) {
    globalThis.__WPAA_SSR__.seo = { title, description, path, noindex, image };
  }

  useEffect(() => {
    const baseTitle = title || '';
    const alreadyHasBrand = /\bWPAA\b|White Paper/i.test(baseTitle);
    const fullTitle = baseTitle ? (alreadyHasBrand ? baseTitle : `${baseTitle} | WPAA`) : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESCRIPTION;
    const url = path ? `${SITE_ORIGIN}${path}` : SITE_ORIGIN;

    document.title = fullTitle;
    upsertMeta('name', 'description', desc);
    upsertMeta('property', 'og:title', fullTitle);
    upsertMeta('property', 'og:description', desc);
    upsertMeta('property', 'og:url', url);
    upsertMeta('name', 'twitter:title', fullTitle);
    upsertMeta('name', 'twitter:description', desc);
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    if (noindex) upsertMeta('name', 'robots', 'noindex, follow');
    if (image) setImage(`${SITE_ORIGIN}${image}`);

    return () => {
      if (image) setImage(DEFAULT_IMAGE);
      document.title = DEFAULT_TITLE;
      upsertMeta('name', 'description', DEFAULT_DESCRIPTION);
      if (noindex) document.querySelector('meta[name="robots"]')?.remove();
    };
  }, [title, description, path, noindex, image]);
};

export default usePageSeo;
